module.exports = __webpack_public_path__ + "static/img/16065C_5_6_7_R_20200601_LC.6ab9976.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/16065C_5_6_7_R_20200601_LC.png
// module id = ok7l
// module chunks = 0